/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function CodeBlockIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "code-block", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M11 16L7.5 12.5L11 9", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("rect", { x: 3.6, y: 4.6, width: 17.8, height: 15.8, stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M14 9L17.5 12.5L14 16", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(CodeBlockIcon);
export default ForwardRef;
//# sourceMappingURL=codeBlockIcon.js.map